import AddTeamMemberProfileForm from "./AddTeamMemberProfileForm";
import { Navigate, useNavigate } from "react-router-dom";
import { buildApiUrl } from "../utils/apiConfig";
import { isCoach } from "../utils/auth";

export default function AddMemberProfile() {
    const navigate = useNavigate();
    const close = () => navigate("/team");
    const userId = localStorage.getItem("loggedInUserId")
    const saveUrl = buildApiUrl(`api/company/member/${userId}`)

    if (isCoach()) {
        return <Navigate to="/team" replace />;
    }

    return (
        <section className={`add-member-profile`}>
            <AddTeamMemberProfileForm
                loadUrl={buildApiUrl("api/company/members/add/view")}
                saveUrl={saveUrl}
                useCookies
                afterSaveTo={"/team"}
                onClose={close}
            />
        </section>
    );
}